import Vue        from 'vue'
import Vuex       from 'vuex'
import app        from './modules/app'
import diction    from './modules/diction'
import {vuexorm}  from './modules/orm'

import Persisted  from 'vuex-persistedstate'
import Secure     from '@/utils/secure'

import localForage  from 'localforage';
import * as getters from './getters'

Vue.use(Vuex)

localForage.setDriver([
  localForage.INDEXEDDB,
  localForage.WEBSQL,
  localForage.LOCALSTORAGE
])

const store = new Vuex.Store({
  namespaced: true,
  strict: true, // process.env.NODE_ENV !== 'production',
  getters,
  modules: {
    app, diction
  },
  state: {},
  mutations: {},
  plugins: [
    vuexorm,
    Persisted({
      storage: {
        getItem: key => window.localStorage.getItem(key),          
        setItem: (key, value) => window.localStorage.setItem(key, value),
        removeItem: key => window.localStorage.removeItem(key)
      }
    })
  ]
})
export default store
